import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import { Link } from "react-router-dom";
import FormatDateString from "../dateFormat";
import AddComment from "./AddComment";
import ModifyComment from "./ModifyComment";
import DeletedCommentJob from "./DeleteCommentJob";
import vAdminformat from '../../adminFormat';
import Swal from "sweetalert2";
import UpdateJob from "./JobUpdate";
import STLViewer from "../Canvas/STLViewer";
import ColorBox from "../ColorBox";
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';
import validateError from "../../ValidateError";

import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import downloadJobPDF from "./DownloadJob";


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const JobViews = ({ JobID, CloseViewJob, onRenderComplete, getJobs }) => {

    const [Job, setJob] = useState({
        jobs: []

    });
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [onCommentID, setOnCommentID] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [statusJob, setStatusJob] = useState([]);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [currentComment, setCurrentComment] = useState("");
    const [currentPart, setCurrentPart] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);


    useEffect(() => {
        const getCurrentJob = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/select?id=${JobID}`, headers);
                console.log({ Here: response.data })
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    setCurrentDateTime(data.date_estimated);
                    setCurrentComment(data.comment);
                    setCurrentPart(data.parts)
                    setCurrentStatus(data.est_ID);
                    setFileURL(`${server_backend}/${data.files_path_file}`)
                    setJob(data)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentJob();
    }, []);

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    useEffect(() => {
        const getTrackingData = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${JobID}`, headers);
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    setTrackingView(data)
                }
            } catch (error) {
                console.log(error)
            }
        }
        getTrackingData();
    }, []);

    const getCurrentJob = async () => {
        try {
            const response = await axios.get(`${server_backend}/jobs/select?id=${JobID}`, headers);
            //console.log(response.data)
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT);
                const data = (response.data.RES_RESULT);
                setCurrentDateTime(data.date_estimated);
                setCurrentComment(data.comment);
                setCurrentPart(data.parts)
                setCurrentStatus(data.est_ID);
                setJob(data);
            }
        } catch (error) {
            console.log(error)
        } finally {
            onRenderComplete && onRenderComplete()
        }
    }

    const getTrackingData = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${JobID}`, headers);
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT)
                const data = (response.data.RES_RESULT);
                setTrackingView(data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const downloadInvoice = () => {
        const element = document.getElementById('invoice-container');

        const options = {
            margin: 0,
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save();
    };

    const printInvoice = () => {
        const printContents = document.getElementById('invoice-container').innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;

    };


    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const currentStep = statusJob.find((status) => status.est_ID === Job.est_ID)?.est_ID || 0;
    const lastStep = Math.max(...statusJob.map((step) => step.est_ID <= currentStep ? step.est_ID : -1));

    const statusDescriptions = {
        18: "In the process of printing the production folder.",
        19: "Preparing the model for building.",
        20: "The model is being invested for molding.",
        21: "Casting process is in progress.",
        22: "Production is complete and ready for review.",
    };



    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);

    return (

        <div className="container-fluid">
            {/*start page title */}
            {isUpdating ? (
                <UpdateJob CloseViewJob={CloseModalUpdate} JobID={JobID} getJobs={getJobs} getCurrentJob={getCurrentJob}  />

            ) : (
                <div>
                    <div className="row justify-content-center">
                        <div className="col-12 card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center mt-3 p-2">
                                  
                                    <div className="hstack text-nowrap gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={CloseViewJob}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Go Back"
                                        >
                                            <i className="ri-arrow-go-back-line"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-warning"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Edit"
                                            onClick={ShowModalUpdate}
                                        >
                                            <i className="ri-pencil-fill align-bottom"></i>
                                        </button>
                                    </div>

                              
                                    <div className="text-center flex-grow-1">
                                        <span className="fw-bold">Order Ref: <Link>{Job.ord_ID}</Link></span>
                                    </div>

                                   
                                    <div className="hstack text-nowrap gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Print"
                                            onClick={handleClick}
                                        >
                                            <i className="ri-printer-line"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Download"
                                            onClick={() => downloadJobPDF(JobID)}
                                        >
                                            <i className="ri-download-2-line"></i>
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-lg-8 col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="d-sm-flex align-items-center">
                                                        <h5 className="card-title flex-grow-1 mb-0">{Job.file_name}</h5>
                                                    </div>
                                                </div>

                                                <div className="card-body" style={{ height: "100%", width: "100%" }}>
                                                    <div className="row">
                                                        {/*STL Viewer */}
                                                        <div className="col-12 mb-4" style={{ height: "224px" }}>
                                                            <STLViewer url={fileURL} currentColor={Job.materials_color} />
                                                        </div>

                                                        {/*QR Code Section */}
                                                        <div className="col-6 d-flex flex-column align-items-center mb-4">
                                                            {Job?.barcode && (
                                                                <>
                                                                    <QRCode
                                                                        size={200}
                                                                        style={{ height: "15vh", width: "15vh" }}
                                                                        value={`${server_frontend}/orders/qr?trs=2&qr=${Job.barcode}`}
                                                                        viewBox="0 0 256 256"
                                                                    />
                                                                    <h6 className="mt-3">Single Back to Print Folder Only</h6>
                                                                </>
                                                            )}
                                                        </div>

                                                        <div className="col-6 d-flex flex-column align-items-center mb-4">
                                                            {Job?.barcode && (
                                                                <>
                                                                    <QRCode
                                                                        size={200}
                                                                        style={{ height: "15vh", width: "15vh" }}
                                                                        value={`${server_frontend}/orders/qr-group?trs=1&qr=${Job.qrcode}`}
                                                                        viewBox="0 0 256 256"
                                                                    />
                                                                    <h6 className="mt-3">Quick Scan Group</h6>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="d-sm-flex align-items-center">
                                                        <h5 className="card-title flex-grow-1 mb-0">Information</h5>
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                    <td className="text-end">{Job.volume}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                    <td className="text-end">{Job.area}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Weight:</h6></td>
                                                                    <td className="text-end">{Job.weight}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Dimensions:</h6></td>
                                                                    <td className="text-end">{Job.dimensions}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Material:</h6></td>
                                                                    <td className="text-end">
                                                                        <ColorBox color={Job.materials_color} />
                                                                        <span className="ms-2" style={{ marginBottom: "7px" }}>{Job.materials_name}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="d-sm-flex align-items-center">
                                                    <h5 className="card-title flex-grow-1 mb-0">Job Information</h5>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Name:</h6></td>
                                                                    <td className="text-end">{Job.fullname}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Job Number:</h6></td>
                                                                    <td className="text-end">{Job.job_number}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Description:</h6></td>
                                                                    <td className="text-end">{"Wed band"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Alloy:</h6></td>
                                                                    <td className="text-end">
                                                                        {Job.materials_name}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="font-weight-bold"><h6>Date:</h6></td>
                                                                    <td className="text-end">{vAdminformat.FormatDate(Job.date_created)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-12 mb-3">
                                            <div className="row mt-3">
                                                {/*Estimated Completion Date Field */}
                                                <div className="col-6 d-flex flex-column">
                                                    <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control text-center"
                                                        id="estimatedCompletionInput"
                                                        value={currentDateTime} //Set default value to current date and time
                                                        disabled
                                                        onChange={(e) => setCurrentDateTime(e.target.value)} //Allow user to change the date and time
                                                    />
                                                </div>

                                                {/*Parts Field */}
                                                <div className="col-6 d-flex flex-column">
                                                    <label htmlFor="partsInput" className="form-label">Parts</label>
                                                    <input
                                                        type="number"
                                                        className="form-control text-center"
                                                        id="partsInput"
                                                        value={parseInt(currentPart)}
                                                        onChange={(e) => setCurrentPart(e.target.value)}
                                                        disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <textarea
                                                value={currentComment}
                                                className="form-control"
                                                disabled
                                                style={{ height: "13vh", width: "100%", resize: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 mt-3 mt-lg-0">

                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-sm-flex align-items-center">
                                                <h5 className="card-title flex-grow-1 mb-0">Order Status</h5>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="profile-timeline">
                                                <div className="accordion accordion-flush">
                                                    {statusJob.map((step) => (
                                                        <div className="accordion-item border-0" key={step.est_ID}>
                                                            <div className="accordion-header" id={`heading${step.est_ID}`}>
                                                                <div
                                                                    className={`accordion-button p-2 shadow-none ${step.est_ID <= currentStep ? "bg-highlighted" : ""}`}
                                                                >
                                                                    <div className="d-flex align-items-center w-100">
                                                                        <div className="flex-shrink-0 avatar-xs th-hover-status">
                                                                            <div
                                                                                className={`avatar-title ${step.est_ID <= currentStep ? "bg-secondary" : "bg-light text-secondary"} rounded-circle`}
                                                                                
                                                                            >
                                                                                <i className="ri-check-line"></i>
                                                                            </div>
                                                                        </div>

                                                                        <div className="flex-grow-1 ms-3">
                                                                            <h6 className="fs-15 mb-1 fw-semibold">{step.name}</h6>
                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/*Display description for each status */}
                                                            <div
                                                                id={`collapse${step.est_ID}`}
                                                                className="accordion-collapse collapse show"
                                                                aria-labelledby={`heading${step.est_ID}`}
                                                            >
                                                                <div className="accordion-body ms-2 ps-5 pt-0 p-0">
                                                                    <p className="text-muted">{vAdminformat.FormatDate(Job.date_created)}</p>
                                                                    <p className="text-muted">{statusDescriptions[step.est_ID]}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                            {/*end card*/}

                        </div>
                    </div>
                </div>
            )}


            {/*end row*/}
            {isComment && (
                <AddComment JobID={JobID} onClose={CloseAddCommentModal} getJobs={getTrackingData} />
            )}
            {isModifiyComment && (
                <ModifyComment JobID={JobID} onCommentID={onCommentID} onClose={CloseModifyCommentModal} getJobs={getTrackingData} />
            )}

            <div>

                {showPrintableDiv && (
                    <div ref={componentRef} id="printable-area" className="container mt-4 p-4" style={{ width: '500px', padding: '20px' }}>
                        <div className="row">
                            <div className="col-12 mb-4">
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Name:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{Job.fullname}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Job Number:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{Job.job_number}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Date:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{vAdminformat.FormatDate(Job.date_created)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Description:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{"define"}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Parts:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{Job.parts}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '4px 8px' }}><strong>Alloy:</strong></td>
                                            <td style={{ padding: '4px 8px' }}>{Job.materials_name}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-12">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="text-center">
                                            {imageURL ? (
                                                <img src={imageURL} alt="STL Image" style={{ width: '100%', height: '16vh', minWidth: '16vh', border: '1px solid #ccc' }} />
                                            ) : (
                                                <p>Loading Image...</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-6" style={{ paddingLeft: '10px' }}>
                                        <div className="row">
                                            <div className="col-6 text-center">
                                                {Job?.barcode && (
                                                    <QRCode
                                                        size={100}
                                                        value={`${server_frontend}/orders/qr-group?trs=1&qr=${Job.qrcode}`}
                                                        style={{ marginBottom: '10px' }}
                                                    />
                                                )}
                                            </div>
                                            <div className="col-6 text-center">
                                                <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Quick scan group</h6>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6 text-center">
                                                {Job?.barcode && (
                                                    <QRCode
                                                        size={100}
                                                        value={`${server_frontend}/orders/qr?trs=2&qr=${Job.barcode}`}
                                                    />
                                                )}
                                            </div>
                                            <div className="col-6 text-center">
                                                <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Single back to Print folder ONLY</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>

    )
}


export default JobViews;